module.exports = __webpack_public_path__ + "img/chat-sidebar@2x.2ae4b016.png";